var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-3cy68l",
    "aria-label": "stars-alt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.896 18.913L19.865 19.939C20.248 20.139 20.696 19.816 20.623 19.393L20.247 17.218L21.84 15.678C22.15 15.378 21.979 14.855 21.55 14.793L19.349 14.475L18.364 12.494C18.172 12.108 17.618 12.108 17.427 12.494L16.442 14.475L14.241 14.793C13.813 14.855 13.641 15.378 13.951 15.678L15.544 17.218L15.168 19.393C15.095 19.816 15.543 20.14 15.926 19.939L17.895 18.913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 10.707L13.968 11.733C14.351 11.933 14.799 11.61 14.726 11.187L14.35 9.012L15.943 7.472C16.253 7.172 16.082 6.649 15.653 6.587L13.453 6.27L12.468 4.289C12.276 3.903 11.722 3.903 11.531 4.289L10.547 6.27L8.345 6.588C7.917 6.65 7.745 7.173 8.055 7.473L9.648 9.013L9.272 11.188C9.199 11.611 9.647 11.935 10.03 11.734L11.999 10.708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.102 18.913L8.071 19.939C8.454 20.139 8.902 19.816 8.829 19.393L8.453 17.218L10.046 15.678C10.356 15.378 10.185 14.855 9.756 14.793L7.555 14.475L6.57 12.494C6.378 12.108 5.824 12.108 5.633 12.494L4.648 14.475L2.447 14.793C2.019 14.855 1.847 15.378 2.157 15.678L3.75 17.218L3.374 19.393C3.301 19.816 3.749 20.14 4.132 19.939L6.101 18.913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateus);
export default __webpack_public_path__ + "static/media/rateus.a4f5a317aa2e5cc5e257f153325a4421.svg";
export { ForwardRef as ReactComponent };